import React from 'react'
import "./aboutUs.css"
import Carousel from 'react-bootstrap/Carousel';
import ssa4 from "../../imagens/ssa/ssa4.png"
import ssa5 from "../../imagens/ssa/ssa5.JPG"
import ssa6 from "../../imagens/ssa/ssa6.JPG"
import ssa7 from "../../imagens/ssa/ssa7.JPG"
import wireProduciton1 from "../../imagens/wireProduction/wireProduction1.png"
import wireProduciton2 from "../../imagens/wireProduction/wireProduction2.png"

import aboutUsimage from "../../imagens/aboutUs/aboutUs.png"
import aboutUsimage2 from "../../imagens/aboutUs/aboutUs2.png"
import aboutUsimage3 from "../../imagens/aboutUs/aboutUs3.png"
import aboutUsimage4 from "../../imagens/aboutUs/aboutUs4.png"
import aboutUsimage6 from "../../imagens/aboutUs/aboutUs6.png"
import aboutUsimage7 from "../../imagens/aboutUs/aboutUs7.png"
import aboutUsimage8 from "../../imagens/aboutUs/aboutUs8.png"
import aboutUsimage9 from "../../imagens/aboutUs/aboutUs9.png"
import aboutUsimage10 from "../../imagens/aboutUs/aboutUs10.png"
import aboutUs from "../../imagens/ssa/aboutUs.png"
import aboutUs2 from "../../imagens/ssa/aboutUs2.png"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';



function AboutUs() {
  return (
    <div className='container-fluid m-0 p-0' id="aboutUs">
      <div className="row m-0 d-flex align-items-center justify-content-around">
        <div className="col-lg-5 col-md-5  m-0 p-0 align-items-center TextAboutUs">
          <h1 className="text-center my-4">About us</h1>
          <p className="px-4 TextAboutUs">With more than 25 years experience, 
            SPI Automotive is specialized in the development and production of a wide range of solutions
            for the automotive industry. We offer customized, 
            high-quality solutions through the efficiency and safety of our products. 
            Our commitment to innovation, excellence in production and focus on exceeding our customers needs 
            leads us as an strategic partner in the automotive market.</p>
          <div className='text-center'>
            <div className="text-center">
              <Link to="/Capabilities">
                <button type="button" className="align-items-center buttonCapabilities">
                  See our capabilities    
                  <FontAwesomeIcon className='ms-2' icon={faArrowRight} />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className='col-lg-6 col-md-6 text-center mt-4 px-0 pt-5  '>
          <Carousel className='mx-2 mb-3'>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa5}
                alt="ssa1"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={wireProduciton1}
                alt="ss2"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={wireProduciton2}
                alt="ss3"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa4}
                alt="ss4"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUs}
                alt="ss5"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUs2}
                alt="ss6"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage}
                alt="ss7"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa6}
                alt="ss8"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={ssa7}
                alt="ss9"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage2}
                alt="ss10"
              />
            </Carousel.Item>

            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage3}
                alt="ss11"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage4}
                alt="ss12"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage6}
                alt="ss13"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage7}
                alt="ss14"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage8}
                alt="ss15"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage9}
                alt="ss16"
              />
            </Carousel.Item>
            <Carousel.Item interval={3000}>
              <img
                className="d-block w-100 custom-height"
                src={aboutUsimage10}
                alt="ssa17"
              />
            </Carousel.Item>
            
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default AboutUs